import styles from './MapSection.module.scss';
import SectionTagCopy from "../../../../components/SectionTagCopy/SectionTagCopy";

const MapSection = () => {
    return (
        <section id="location" className={styles.section}>
            <SectionTagCopy anchorId="location"/>
            <iframe
                className={styles.map}
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d745.867237363822!2d54.65657707880493!3d58.07871527107919!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x43e5ef3e5f51d6c1%3A0xf440da182b07feca!2z0JfQntCe0JTQntCa0KLQntCg!5e0!3m2!1sru!2sru!4v1747568685569!5m2!1sru!2sru"
                loading="lazy"
            />
        </section>
    );
};

export default MapSection;
